/* eslint-disable */
import React, {useEffect, useRef, useState} from 'react';
import './SubscriptionDetail.css';
import { quizService } from '../../../../api/quizService';
import {useTranslation} from "react-i18next";
import {useUserChoicesStore} from "../../../../store/userChoicesStore";
import {pushInfoToGoogleData} from "../../../../utils/googleTag";
import {facebookEventFire} from "../../../../utils/facebookEventFire";
import TestimonialCard from "../../../../components/TestimonialCard/TestimonialCard";
import PopupCard from "../../../../components/PopupCard";
import {CourseScreenshotsSlider} from "../../../../components/CourseScreenshotsSlider/CourseScreenshotsSlider";
import {RatingBlock} from "../../../../components/RatingBlock";
import PaymentLogos from "../components/PaymentLogos";
import {useParams} from "react-router-dom";
import FAQBlock from "./components/FAQBlock";
import TestimonialsBlock from "./components/TestimonialsBlock";
import WhatYouGetBlock from "./components/WhatYouGetBlock";
import SupportBlock from "./components/SupportBlock";
import PaymentInfoBlock from "./components/PaymentInfoBlock";
import PlanListBlock from "./components/PlanListBlock";
import UnlockAIPotentialBlock from "./components/UnlockAIPotentialBlock";
import AiEasyBlock from "./components/AiEasyBlock";
import GoalTargetBlock from "./components/GoalTargetBlock";
import ReadinessScoreBlock from "./components/ReadinessScoreBlock";
import ProgressComparisonBlock from "./components/ProgressComparisonBlock";
import TimerBlock from "./components/TimerBlock";

export interface StripePrice {
    id: string;
    object: string;
    active: boolean;
    billing_scheme: string;
    created: number;
    currency: string;
    custom_unit_amount: null;
    livemode: boolean;
    lookup_key: null;
    metadata: Record<string, any>;
    nickname: null;
    product: string;
    recurring: {
        interval: string;
        interval_count: number;
        meter: null;
        trial_period_days: null;
        usage_type: string;
    };
    tax_behavior: string;
    tiers_mode: null;
    transform_quantity: null;
    type: string;
    unit_amount: number;
    unit_amount_decimal: string;
}

export interface SubscriptionDetailContent {
    title?: string;
    description?: string;
    buttonText?: string;
    nextStep?: number;
    stripeProductId?: string;
    subRenewDescriptionShow?: boolean;
    scoreLevel?: string;
    scoreTitle?: string;
    scoreDescription?: string;
    frequentQuestions?: { title?: string; items?: { id: number; question: string; answer: string }[] };
    futureSkills?: { title?: string; items?: any[] };
    supportBlock?: { title?: string; description?: string; banner?: any };
    featureList?: { title?: string; items?: any[] };
    comments?: { id: number; name: string; rating: number; text: string; avatar?: string }[];
    comparisonCards?: Array<{
        id: number;
        title: string;
        skillLevelLabel: string;
        aiSkillsLabel: string;
        aiSkillsValue: number;
        incomePotentialLabel: string;
        incomePotentialValue: number;
        image?: any;
    }>;
}

export interface SubscriptionDetailProps {
    content: SubscriptionDetailContent;
    stepIndex: number;
    onCheckout: ({selectedPrice, coupon, isSingle, productId}: { selectedPrice: StripePrice, coupon: any, isSingle: boolean, productId: string }) => void;
    step: any;
}


export const CouponContext = React.createContext<any>(null);

const SubscriptionDetail: React.FC<SubscriptionDetailProps> = ({ content, onCheckout, step, stepIndex }) => {
    const { t } = useTranslation();
    const { funnelId} = useParams<{ funnelId: string; version: string }>();
    const { choices } = useUserChoicesStore();
    const [prices, setPrices] = useState<StripePrice[]>([]);
    const [productId, setProductId] = useState('');
    const [pricesList, setPricesList] =  useState<StripePrice[]>([]);
    const [selectedPriceId, setSelectedPriceId] = useState<string>('');
    const [selectedPrice, setSelectedPrice] = useState<StripePrice | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds
    const [isTimerFixed, setIsTimerFixed] = useState(false);
    const [coupon, setCoupon] = useState<any>(null);
    const [goalObject, setGoalObject] = useState<string>('');
    const [targetObject, setTargetObject] = useState<string>('');
    const [isPriceSingle, setSinglePriceSelected ] = useState<boolean>(false);
    const [cardVisibility, setCardVisibility] = useState<boolean>(false);
    const continueBtnRef = useRef<HTMLDivElement | null>(null);
    const paymentBlockRef = useRef<HTMLDivElement | null>(null)

    // Show PopupCard when the continue button comes into view
    useEffect(() => {
        const target = continueBtnRef.current;
        if (!target) return;

        const observer = new IntersectionObserver((entries) => {
          console.log('continueBtnRef', entries);
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                  console.log('intersected', entry);
                    setTimeout(() => setCardVisibility(true), 2000);
                    // Show only once per visit
                    observer.unobserve(entry.target);
                }
            });
        }, { root: null, threshold: 0.2 });

        observer.observe(target);
        return () => {
            try { if (target) observer.unobserve(target); } catch {}
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        pushInfoToGoogleData({
            event: 'subscription_page_view',
            data: {
                stepId: step.stepId,
                cardTitle: step.title,
                stepIndex,
            }
        })
        facebookEventFire('SubscriptionPageView', {
          customData: {stepId: step.stepId, cardTitle: step.title, stepIndex},
          userData: {}
        })
        const handleScroll = () => {
            setIsTimerFixed(window.scrollY >= 80);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const loadPrices = async () => {
            try {
                console.log('funnel id ', funnelId)
                const funnelVersion = funnelId?.replace('f', '')
                const response = await quizService.getProductPrices(funnelVersion || '1');
                if(response.productId){
                    setProductId(response.productId)

                }
                if (response && response.prices && response.prices.data) {
                    const data: StripePrice[] = response.prices.data;

                    setPricesList(data)
                    // Check if any price has selectedSinglePrice flag set to true
                    const singlePrice = data.find(p => {
                        const flag = (p.metadata && (p.metadata.selectedSinglePrice ?? p.metadata["selectedSinglePrice"])) as unknown;
                        if (flag === true) return true;
                        if (typeof flag === 'string') {
                            const normalized = flag.trim().toLowerCase();
                            return normalized === 'true' || normalized === '1' || normalized === 'yes';
                        }
                        return false;
                    });


                    if (singlePrice) {
                        // If selectedSinglePrice exists, show only this price
                        setPrices([singlePrice]);
                        setSelectedPriceId(singlePrice.id);
                        setSelectedPrice(singlePrice);
                        setSinglePriceSelected(true);
                    } else {
                        // Normal behavior: show all prices and select default
                        setPrices(data);

                        // Prefer the price explicitly marked as default via metadata
                        const defaultPrice = data.find(p => {
                            const flag = (p.metadata && (p.metadata.default ?? p.metadata["default"])) as unknown;
                            if (flag === true) return true;
                            if (typeof flag === 'string') {
                                const normalized = flag.trim().toLowerCase();
                                return normalized === 'true' || normalized === '1' || normalized === 'yes';
                            }
                            return false;
                        });

                        if (defaultPrice) {
                            setSelectedPriceId(defaultPrice.id);
                            setSelectedPrice(defaultPrice);
                        } else if (data.length > 1) {
                            // Fallback to previously selected behavior: second price if multiple
                            setSelectedPriceId(data[1].id);
                            setSelectedPrice(data[1]);
                        } else if (data.length > 0) {
                            setSelectedPriceId(data[0].id);
                            setSelectedPrice(data[0]);
                        }
                    }
                }
            } catch (err) {
                setError(t('subscription.failedToLoadPrices'));
                console.error('Error loading prices:', err);
            } finally {
            }
        };
        loadPrices();
    }, [productId, t]);

    useEffect(() => {
        const found = prices.find(p => p.id === selectedPriceId) || null;
        setSelectedPrice(found);
    }, [selectedPriceId, prices]);

    // Fetch coupons and select the first one if available
    useEffect(() => {
        const fetchCoupons = async () => {
            if (!productId) return;
            try {
                const res = await quizService.getCouponByProductId(productId);
                if (res && res.coupons && res.coupons.data && res.coupons.data.length > 0) {
                    setCoupon(res.coupons.data[0]);
                }
            } catch (e) {
                // Optionally handle coupon fetch error
            }
        };
        fetchCoupons();
    }, [productId]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    // Get goal from step 11 of funnel
    useEffect(()=> {
        // Search for goal in choices array
        const goalChoice = choices.find(choice => choice?.goal === true);
        const targetChoice = choices.find(choice => choice?.target === true)
        if (goalChoice?.optionValue) {
            setGoalObject(goalChoice);
        }
        if(targetChoice?.optionValue){
            setTargetObject(targetChoice)
        }
    }, [choices])

    const handleCheckout = () => {
        if (selectedPrice) {
            onCheckout({ selectedPrice, coupon, isSingle: isPriceSingle, productId: productId });
        }
    };

    const scrollToCheckout = () => {
        setTimeout(() => {
                const paymentElement = paymentBlockRef.current?.querySelectorAll('.unlock-ai-title');
                if (paymentElement && paymentElement.length > 0) {
                    const focusFragment = paymentElement[0];
                    if(focusFragment){
                        const positions = position(focusFragment);
                        console.log('window scroll ', window.scrollY)
                        if(window.scrollY === 0){
                            window.scrollTo({ top: positions[1] - 50, behavior: 'smooth' });
                        }else {
                            window.scrollTo({ top: positions[1] - 67, behavior: 'smooth' });
                        }
                    }
                }
        }, 100);

    }
    function position(elem: any) {
        var left = 0,
            top = 0;

        do {
            left += elem.offsetLeft-elem.scrollLeft;
            top += elem.offsetTop-elem.scrollTop;
        } while ( elem = elem.offsetParent );

        return [ left, top ];
    }

    // Directly navigate to checkout instead of showing modal
    const handleGetMyPlanClick = () => {
        handleCheckout();
    };

    // if (loading) {
    //     return <div className="subscription-detail__loading">Loading prices...</div>;
    // }
    if (error) {
        return <div className="subscription-detail__error">{error}</div>;
    }
    return (
        <div className="subscription-detail">
            {isTimerFixed && <div className="subscription-detail__timer-row-placeholder" />}
            <div className={isTimerFixed ? 'subscription-detail__timer-row' : 'subscription-detail__timer-row-second'}>
                {!isTimerFixed ? (
                    <TimerBlock timeLeft={timeLeft} onCheckout={scrollToCheckout} disabled={!selectedPrice} />
                ) : (
                    <div className="subscription-detail__timer-row-inner-fixed">
                        <TimerBlock timeLeft={timeLeft} onCheckout={scrollToCheckout} disabled={!selectedPrice} />
                    </div>
                )}
            </div>
            <div className="subscription-detail__header">
                <h2 className="subscription-detail__title">{content.title}</h2>
                {content.description && <p className="subscription-detail__description">{content.description}</p>}
            </div>
          <PopupCard onClose={() => setCardVisibility(false)} visibility={cardVisibility} />
            <ProgressComparisonBlock comparisonCards={content.comparisonCards} />
            <ReadinessScoreBlock percent={content.scoreLevel} title={content.scoreTitle} description={content.scoreDescription} />
            <GoalTargetBlock goal={goalObject} target={targetObject} />
            <AiEasyBlock />
            <UnlockAIPotentialBlock title={content.featureList?.title} items={content.featureList?.items} forwardRef={paymentBlockRef} />
            <CouponContext.Provider value={coupon}>
              <div ref={continueBtnRef}>
                <PlanListBlock prices={prices}
                               onPlanPressed={handleGetMyPlanClick}
                               onSelect={setSelectedPriceId}
                               selectedId={selectedPriceId}
                               isPriceSingle={isPriceSingle} />
              </div>
            </CouponContext.Provider>
            {!isPriceSingle &&
                <div className="subscription-detail__button-container">
                    <button
                        className="subscription-detail__continue w-full rounded-[12px] md:rounded-[10px] h-14 md:h-12 px-6 md:px-4 text-base md:text-sm font-bold uppercase bg-blue-600 text-white shadow-md hover:bg-blue-700 transition focus:outline-none focus:ring-2 focus:ring-blue-400 disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={handleGetMyPlanClick}
                        disabled={!selectedPrice}
                        tabIndex={0}
                        aria-label={t('subscription.getMyPlan')}
                        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleGetMyPlanClick(); }}
                    >
                        {t('subscription.getMyPlanPayCard').toUpperCase()}
                    </button>
                </div>
            }
          <PaymentInfoBlock
            selectedPrice={selectedPrice}
            subRenewDescriptionShow={!!content?.subRenewDescriptionShow}
            isPriceSingle={isPriceSingle}
            prices={pricesList}
          />
          <CourseScreenshotsSlider
            images={
              [
                `${t('subscription.screenshotsSliderFolder')}/screenshot-2.png`,
                `${t('subscription.screenshotsSliderFolder')}/screenshot-1.png`,
                `${t('subscription.screenshotsSliderFolder')}/screenshot-3.png`,
                `${t('subscription.screenshotsSliderFolder')}/screenshot-4.png`,
              ]}
            title={t('courseSlider.title')}
            initialIndex={1}
          />
            <SupportBlock title={content.supportBlock?.title} description={content.supportBlock?.description} banner={content.supportBlock?.banner} />
            <WhatYouGetBlock title={content.futureSkills?.title} items={content.futureSkills?.items} />
            <TestimonialsBlock comments={content.comments} />
            <FAQBlock title={content.frequentQuestions?.title} items={content.frequentQuestions?.items} />
            {/* CTA Block after FAQ */}
            <div className="cta-block">
                <div className="cta-title">{t('subscription.readyToStart')}</div>
                <button
                    className="cta-btn"
                    onClick={scrollToCheckout}
                    disabled={!selectedPrice}
                    tabIndex={0}
                    aria-label={t('subscription.getMyPlan')}
                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') scrollToCheckout(); }}
                >
                    {t('subscription.getMyPlan').toUpperCase()}
                </button>
            </div>
        </div>
    );
};

export default SubscriptionDetail;
